import type { AppScope } from 'v5/core/app-scope/appScope.types';
import { myAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService.connected';

/**
 * Browsing scope for booking-confirmation send.
 * UserFlow takes `appScope` only (org → global template, `/w/…` → that workspace).
 */
export function useBrowsingWorkspaceForBookingConfirmation(): {
  appScope: AppScope;
} {
  const appScope = myAppScopeService.useSlugAppScope();
  return { appScope };
}
